"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _getCountryCodeFromLocale = _interopRequireDefault(require("./getCountryCodeFromLocale"));

var _salesPhoneNumbers = _interopRequireDefault(require("ui-addon-upgrades/_core/common/constants/salesPhoneNumbers"));

function _default(lang, locale) {
  if (_salesPhoneNumbers.default[locale]) {
    var countryCode = (0, _getCountryCodeFromLocale.default)(locale).toUpperCase();
    return _salesPhoneNumbers.default[locale][lang] ? {
      phoneNumber: _salesPhoneNumbers.default[locale][lang],
      countryCode: countryCode
    } : {
      phoneNumber: _salesPhoneNumbers.default[locale].en,
      countryCode: countryCode
    };
  }

  return {
    phoneNumber: _salesPhoneNumbers.default.DEFAULT,
    countryCode: 'US'
  };
}

module.exports = exports.default;